import React, { useEffect } from "react";
import FreshchatWidget from "../components/FreshchatWidget/index.jsx";
import { masterActions } from "../_store/index.js";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const PublicRoute = ({ children }) => {
  const maintenanceData = useSelector((state) => state.master.maintenanceMode);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // Function to handle user interaction and check for maintenance mode
  const handleUserAction = () => {
    dispatch(masterActions.GetApplicationSettings("WEB"))
      .then((result) => {
        const data = result?.payload;
        if (
          Object?.keys(data || {}).length === 0 ||
          data?.IsApplicationMaintenance === 0
        ) {
          return; // Do nothing if no maintenance
        }

        navigate("/public/Maintenance");
      })
      .catch((err) => {
        console.error("Failed to fetch maintenance data", err);
      });
  };

  // Attach event listeners for user interaction
  useEffect(() => {
    const events = ["click", "keydown"];
    events.forEach((event) =>
      window.addEventListener(event, handleUserAction)
    );
    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserAction)
      );
    };
  }, [maintenanceData]);

  // Initial maintenance check
  useEffect(() => {
    handleUserAction();
  }, []);

  return (
    <>
      <FreshchatWidget />
      {children}
    </>
  );
};

export default PublicRoute;
